if (document.body.classList.contains("home") && window.innerWidth > 1024) {
    let svg = document.querySelector(".mv__shapesShape")
    let mouse = {
        x: 0,
        y: 0
    }
    let raito = window.innerWidth / window.innerHeight

    window.addEventListener("resize", () => {
        raito = window.innerWidth / window.innerHeight
    })

    window.addEventListener("mousemove", async (e) => {
        if (svg.getBoundingClientRect().bottom >= 0 && document.body.classList.contains("splashed")) {
            mouse.x = (e.clientX / window.innerWidth - 0.5) * 6
            mouse.y = (e.clientY / window.innerHeight - 0.5) * 6 * raito
            svg.style.transform = ` translate(${mouse.x}%,${mouse.y}%) rotate(-118.94deg) `
        }
    })
}